import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/merchants/inbounds/inventory_batches/items'

const MerchantInventoryBatchItemsApiV2 = {
  /**
   * Get list of `Merchant::Inbound::Inventory::Batch::Item`
   * @param {object} params - Filter Object
   * @param {object} params.tableState - ReactTable final state
   * @param {object} params.additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Create Merchant::Inbound::Item::Reject
   * Inovke `POST api/v2/admins/merchant/inbounds/inventory_batches/items/reject_post_curation`
   * @param {string} reject_reason - Reject Reason by Photo studio team
   * @param {string} reject_note - note added (optional)
   */
  rejectPostCuration: async ({
    id,
    reject_reason,
    reject_note
  }) => {
    const endpoint = `${API_PATH}/reject_post_curation`
    const payload  = {
      inventory_batch_item: {
        id            : id,
        reject_reason : reject_reason,
        reject_note   : reject_note
      }

    }

    const response = axios.post(endpoint, payload)
    return response
  },

  /**
   * Change Merchant::Inbound::InventoryBatch::Item put_away status to 'partial' or 'completed'
   * Inovke `PATCH api/v2/admins/merchant/inbounds/inventory_batches/items/put_away`
   * @param {string} inventory_batch_id - Merchant::Inbound::InventoryBatch.id
   * @param {array} items - array of object [{sku: 'RF-123-J', quantity: 2},{...},..]
   * @param {string} location_id - TlWarehouseLocation.id
   */
  putAwayItems: async ({
    inventory_batch_id,
    items,
    location_id
  }) => {
    const endpoint = `${API_PATH}/put_away`
    const payload  = {
      inventory_batch_id : inventory_batch_id,
      items              : items,
      location_id        : location_id
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * Change Merchant::Inbound::InventoryBatch::Item photo received back to 'pending'
   * Inovke `PATCH api/v2/admins/merchant/inbounds/inventory_batches/items/:id/photo_studio_pending_receive`
  **/
  photoStudioPendingReceive: async ({ id }) => {
    const endpoint = `${API_PATH}/${id}/photo_studio_pending_receive`
    const response = axios.patch(endpoint)
    return response
  }
}

export default MerchantInventoryBatchItemsApiV2
